import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import { initializeChangePasswordForm } from 'actions/FormActions';
import { showError, showSnackbar, closeDialogChangePassword } from 'actions/CommonActions';
import { changePassword } from 'actions/EntityActions';
import { selectChangePasswordModel } from '../../../selectors/entitySelector';
import LOOKUP from 'constants/lookup';
import util from '../../../library/util';
import DialogHeader from 'screens/components/basic/DialogHeader'
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class ChangePasswordDialog extends Component {
    constructor(props, context) {
        super(props, context);
    }

    // componentWillMount() {
    //     this.props.initializeChangePasswordForm(this.props.authenticatedUser.userName);
    // }

    componentWillReceiveProps(newProps) {
        if (this.props.isChangePasswordModalOpen !== newProps.isChangePasswordModalOpen && newProps.isChangePasswordModalOpen === true) {
            this.props.initializeChangePasswordForm(this.props.authenticatedUser.userName);
        }

        if (newProps.changePasswordSaveTimeStamp && this.props.changePasswordSaveTimeStamp !== newProps.changePasswordSaveTimeStamp) {
            if (newProps.changePasswordSuccess === true) {
                this.changePasswordSuccess();
            }
            else if (newProps.changePasswordSuccess === false) {
                this.changePasswordFailure();
            }
        }
    }

    changePassword = () => {
        const changePassword = this.props.changePasswordModel;
        const validators = [
            ['changePasswordUserName', changePassword => (changePassword.UserName !== null && changePassword.UserName !== ""), "UserName"],
            ['changePasswordPassword', changePassword => (changePassword.Password !== null && changePassword.Password !== ""), 'Password'],
            ['changePasswordNewPassword', changePassword => (changePassword.NewPassword !== null && changePassword.NewPassword !== ""), 'New Password']
        ];

        if(changePassword.Password && changePassword.NewPassword === changePassword.Password) {
            validators.push(['changePasswordNewPassword', changePassword => (changePassword.NewPassword !== changePassword.Password), "The new password is the same the old password, New password"]);
        }

        if (util.validate(validators, changePassword, this.props.formError)) {
            this.props.changePassword(this.props.changePasswordModel);
        }       
    }

    changePasswordSuccess = () => {
        this.props.showSnackbar(LOOKUP.authentication.changePasswordSuccessMessage);
        this.props.initializeChangePasswordForm(this.props.authenticatedUser.userName);
        this.props.closeDialogChangePassword();
    }

    changePasswordFailure = () => {
        this.props.showError(LOOKUP.authentication.changePasswordErrorMessage);
    }

    closeDialogChangePassword = () => {
        this.props.initializeChangePasswordForm(this.props.authenticatedUser.userName);
        this.props.closeDialogChangePassword();
    }

    render() {
        const p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose text="TechPOS Change Password" handleClose={() => this.closeDialogChangePassword()} />}
                titleStyle={{ textAlign: 'center' }}
                modal={true}
                open={p.isChangePasswordModalOpen}
                autoScrollBodyContent={false}>
                <ContainerDivided>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-12">
                                <TextInput name={`changePasswordUserName`} disabled={true} hintText="Username" fullWidth={true} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <TextInput name={`changePasswordPassword`} hintText="Old Password" fullWidth={true} type="password" maxLength={20} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <TextInput name={`changePasswordNewPassword`} hintText="New Password" fullWidth={true} type="password" maxLength={20} />
                            </div>
                        </div>

                        <div className="pw_msg margin-bottom">
                            <p>New password must:</p>
                            <div>
                                <li>Have between 8 and 20 characters</li>
                                <li>Contain at least a number</li>
                                <li>Contain at least a uppercase character</li>
                                <li>Contain at least a special character</li>
                            </div>
                        </div>

                        <Button 
                            type="Button"
                            className="corner_X" 
                            onTouchTap={() => this.closeDialogChangePassword()} />
                
                        <Button 
                            label="Change Password" 
                            style={{ width: "90%" }} 
                            primary onTouchTap={() => this.changePassword()} />
                    </div>
                    
                </ContainerDivided>
            </DialogInput >
        );
    }
}


function mapStateToProps(state) {
    return {
        changePasswordModel: selectChangePasswordModel(state),
        isChangePasswordModalOpen: state.common.isChangePasswordModalOpen,
        changePasswordSuccess: state.form.changePasswordSuccess,
        changePasswordSaveTimeStamp: state.form.changePasswordSaveTimeStamp,
        authenticatedUser: state.common.authenticatedUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        initializeChangePasswordForm: (userName) => dispatch(initializeChangePasswordForm(userName)),
        changePassword: (model) => dispatch(changePassword(model)),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        closeDialogChangePassword: () => dispatch(closeDialogChangePassword())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordDialog);